<template>
  <v-app>
    <nuxt-layout>
      <nuxt-page />
    </nuxt-layout>
    <toast-snackbar-queue />
  </v-app>
</template>

<script setup lang="ts">
const localSettings = useLocalSettings();

const colorSchemeQueryList = window.matchMedia('(prefers-color-scheme: dark)');
const systemThemeIsDark = ref<boolean>(colorSchemeQueryList.matches);
colorSchemeQueryList.addEventListener('change', (event) => {
  systemThemeIsDark.value = event.matches;
});

const vuetifyTheme = useTheme();
const themeName = computed(() => {
  let theme = localSettings.theme;
  if (!theme || !['light', 'dark'].includes(theme)) {
    // Use system theme
    if (systemThemeIsDark.value) {
      theme = 'dark';
    } else {
      theme = 'light';
    }
  }
  return theme;
});
watch(themeName, () => {
  document.documentElement.style.setProperty('color-scheme', (themeName.value.toLowerCase().includes('dark') ? 'dark' : 'light'));
  vuetifyTheme.change(themeName.value);
}, { immediate: true });
</script>
